import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { AppUtilService } from '../utils/app-util.service';
import { BaseComponent } from '../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { device } from 'tns-core-modules/platform/platform';
import { AppCacheService } from '../services/cache/app-cache.service';
import { AppConfigService } from '../services/init/app-config.service';

@Injectable()
export class isAssociationExists extends BaseComponent implements CanActivate {
  /***************Constructor***************/
  constructor(private userService: UserService, deviceDetectorService: DeviceDetectorService,
    private cache: AppCacheService,  private appConfig: AppConfigService) {
    super(deviceDetectorService, cache, appConfig);
  }
  /***************Constructor***************/

  /******************Implementation Methods******************/

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const isCustomerAsscociationExists = this.userService.isAssociationExists();
    const UserCustomerRef = isCustomerAsscociationExists?.userCustomerXrefs
    if (UserCustomerRef.length > 0) {
      return true;
    } else {
      this.isMobileDevice()
        ? AppUtilService.redirectToHomeMobile()
        : AppUtilService.redirectToHome();
      return false;
    }
  }

  /******************Implementation Methods******************/
}
